export const FlechaIzquierda = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className="w-6 h-6"
        style={{ width: "15px", color: "#6b7280" }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5"
        />
      </svg>
    );
  };
  
  export const FlechaDerecha = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth="1.5"
        stroke="currentColor"
        className="w-6 h-6"
        style={{ width: "15px", color: "#6b7280" }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
        />
      </svg>
    );
  };
  
  export const FlechaMenor = ({ fill }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill={fill}
      >
        <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
        <path fill="none" d="M0 0h24v24H0z" />
      </svg>
    );
  };
  
  export const FlechaMayor = ({ fill }) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill={fill}
      >
        <path d="M14 6l1.41 1.41L10.83 12l4.58 4.59L14 18l-6-6z" />
        <path fill="none" d="M0 0h24v24H0z" />
      </svg>
    );
  };
  
  export const Masculino = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="#4a89ba" // Cambia el color a azul
        strokeWidth="4" // Aumenta el grosor de las líneas
        viewBox="0 0 16 16"
      >
        <path
          fillRule="evenodd"
          d="M9.5 2a.5.5 0 0 1 0-1h5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0V2.707L9.871 6.836a5 5 0 1 1-.707-.707L13.293 2zM6 6a4 4 0 1 0 0 8 4 4 0 0 0 0-8"
          stroke="#4a89ba" // Color del contorno
          strokeWidth="0.8" // Grosor del contorno
        />
      </svg>
    );
  };
  
  export const Femenino = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="#eeacb2" // Cambia el color a rosado oscuro
        strokeWidth="4" // Aumenta el grosor de las líneas
        viewBox="0 0 16 16"
      >
        <path
          fillRule="evenodd"
          d="M8 1a4 4 0 1 0 0 8 4 4 0 0 0 0-8M3 5a5 5 0 1 1 5.5 4.975V12h2a.5.5 0 0 1 0 1h-2v2.5a.5.5 0 0 1-1 0V13h-2a.5.5 0 0 1 0-1h2V9.975A5 5 0 0 1 3 5"
          stroke="#eeacb2" // Color del contorno
          strokeWidth="0.8" // Grosor del contorno
        />
      </svg>
    );
  };
  
  